import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Menu } from "antd";
import {
  HomeOutlined,
  UserOutlined,
  AppstoreOutlined,
  PullRequestOutlined,
  ContactsOutlined,
  EnvironmentOutlined,
  SettingOutlined,
  TeamOutlined,
} from "@ant-design/icons";

const readRole = () => {
  try {
    const parsed = JSON.parse(localStorage.getItem("adminData") || "{}");
    return parsed?.role;
  } catch (e) {
    return undefined;
  }
};

const buildMenuItems = (role) => [
  { key: "/home", icon: <HomeOutlined />, label: "Home" },
  { key: "/users", icon: <UserOutlined />, label: "Users" },
  { key: "/services", icon: <AppstoreOutlined />, label: "Services" },
  { key: "/req-org", icon: <PullRequestOutlined />, label: "Requests" },
  { key: "/contact-us", icon: <ContactsOutlined />, label: "Contact Us" },
  { key: "/locations", icon: <EnvironmentOutlined />, label: "Locations" },
  ...(role === "super_admin"
    ? [{ key: "/admins", icon: <TeamOutlined />, label: "Admins" }]
    : []),
  { key: "/settings", icon: <SettingOutlined />, label: "Settings" },
];

const Sidebar = ({ collapsed }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const role = readRole();
  const menuItems = buildMenuItems(role);

  const getSelectedKey = () => {
    const path = location.pathname;
    if (path === "/home") return "/home";
    if (path === "/services" || path.includes("/service") || path === "/addCompany") {
      return "/services";
    }
    if (path === "/users") return "/users";
    if (path.startsWith("/user-details")) return "/users";
    if (path.startsWith("/guest-details")) return "/users";
    if (path === "/req-org") return "/req-org";
    if (path === "/contact-us") return "/contact-us";
    if (path === "/locations") return "/locations";
    if (path === "/admins") return "/admins";
    if (path === "/settings") return "/settings";
    return "/home";
  };

  const handleClick = ({ key }) => {
    navigate(key);
  };

  return (
    <Menu
      theme="dark"
      mode="inline"
      selectedKeys={[getSelectedKey()]}
      onClick={handleClick}
      items={menuItems}
      style={{ borderRight: 0 }}
    />
  );
};

export default Sidebar;
